import React, { useState } from "react";

export function FadeImg({ src, className = "", ...props }) {
  const [loaded, setLoaded] = useState(null);
  return (
    <img
      key={src}
      src={src}
      onLoad={() => setLoaded(src)}
      className={`${className} transition-opacity duration-500 ${loaded === src ? "opacity-100" : "opacity-0"}`}
      {...props}
    />
  );
}

export function PageHero({ title, subtitle, image, testId }) {
  return (
    <section className="relative overflow-hidden border-b border-white/10 bg-navy-paper" data-testid={testId}>
      {image && (
        <>
          <FadeImg src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/40" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="w-16 h-[3px] bg-gold mb-6" />
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight">{title}</h1>
        {subtitle && <p className="mt-5 max-w-2xl text-slate-300 text-base md:text-lg leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}

export function SectionHeading({ eyebrow, title, className = "" }) {
  return (
    <div className={className}>
      {eyebrow && <div className="text-gold text-xs uppercase tracking-[0.35em] mb-3">{eyebrow}</div>}
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-tight">{title}</h2>
    </div>
  );
}
